import {
  ApiCallState,
  callFailed,
  callInitiated,
  callSucceeded
} from '../../types'
import { addOrUpdateTrade } from './helpers'
import { TradeBlotterActions } from './actions'
import { AdminFields, Trade } from './types'

export interface State {
  tradeBlotter?: Trade[]
  pending: boolean
  error: boolean
  checkoutStatus: ApiCallState
}

export const initialState: State = {
  tradeBlotter: undefined,
  pending: true,
  error: false,
  checkoutStatus: { pending: false, error: false }
}

export default (state = initialState, action: TradeBlotterActions): State => {
  switch (action.type) {
    case 'tradeBlotter.fetch':
      return {
        ...state,
        pending: true,
        error: false,
        tradeBlotter: state.tradeBlotter
      }
    case 'tradeBlotter.fetchCancel':
      return {
        ...state,
        pending: true,
        error: false,
        tradeBlotter: undefined
      }

    case 'tradeBlotter.fetchFail':
      return {
        ...state,
        tradeBlotter: undefined,
        pending: false,
        error: true
      }

    case 'tradeBlotter.addTrades':
      let items: Trade[] = []

      if ('payload' in action) {
        items = action.payload ?? []
      }

      if (!state.tradeBlotter) {
        return {
          ...state,
          tradeBlotter: items,
          pending: false
        }
      }
      return {
        ...state,
        // tradeBlotter: [...state.tradeBlotter, ...items]
        tradeBlotter: addOrUpdateTrade(state.tradeBlotter, items),
        pending: false
      }
    case 'tradeBlotter.confirmTrade': {
      const blotter = state.tradeBlotter?.map((trade) =>
        trade.id === action.payload && trade.adminFields
          ? {
              ...trade,
              adminFields: {
                ...trade.adminFields,
                vconState: 3
              } satisfies AdminFields
            }
          : trade
      )
      return {
        ...state,
        tradeBlotter: blotter
      }
    }
    case 'tradeBlotter.checkoutTicket':
    case 'tradeBlotter.uncheckoutTicket':
      return { ...state, checkoutStatus: { ...callInitiated } }
    case 'tradeBlotter.ticketCheckoutSuccess':
      return { ...state, checkoutStatus: { ...callSucceeded } }
    case 'tradeBlotter.ticketCheckoutFailure':
      return { ...state, checkoutStatus: { ...callFailed } }

    default:
      return state
  }
}
